export const BLOG_COPY = {
  fr: {
    label: "Blog",
    readGuide: "Lire le guide",
    allArticles: "Tous les guides",
    backHome: "Retour à l'accueil",
    notFoundTitle: "Guide introuvable",
    notFoundDesc: "Ce guide n'existe pas ou a été déplacé.",
    ctaTitle: "Créez votre galerie en quelques minutes",
    ctaDesc: "Un QR code, une galerie privée, et des souvenirs rassemblés sans friction.",
    ctaButton: "Créer une galerie",
  },
  en: {
    label: "Blog",
    readGuide: "Read guide",
    allArticles: "All guides",
    backHome: "Back home",
    notFoundTitle: "Guide not found",
    notFoundDesc: "This guide does not exist or has moved.",
    ctaTitle: "Create your gallery in minutes",
    ctaDesc: "One QR code, one private gallery, and memories collected without friction.",
    ctaButton: "Create a gallery",
  },
  es: {
    label: "Blog",
    readGuide: "Leer guía",
    allArticles: "Todas las guías",
    backHome: "Volver al inicio",
    notFoundTitle: "Guía no encontrada",
    notFoundDesc: "Esta guía no existe o fue movida.",
    ctaTitle: "Crea tu galería en minutos",
    ctaDesc: "Un QR, una galería privada y recuerdos reunidos sin fricción.",
    ctaButton: "Crear galería",
  },
  ar: {
    label: "المدونة",
    readGuide: "قراءة الدليل",
    allArticles: "كل الأدلة",
    backHome: "العودة للرئيسية",
    notFoundTitle: "الدليل غير موجود",
    notFoundDesc: "هذا الدليل غير موجود أو تم نقله.",
    ctaTitle: "أنشئ معرضك خلال دقائق",
    ctaDesc: "رمز QR واحد، معرض خاص واحد، وذكريات مجمعة بدون تعقيد.",
    ctaButton: "إنشاء معرض",
  },
};

export const BLOG_POSTS = [
  {
    slug: "collect-event-photos",
    category: {
      fr: "Organisation",
      en: "Planning",
      es: "Organización",
      ar: "تنظيم",
    },
    title: {
      fr: "Comment collecter les photos d'un événement sans friction",
      en: "How to collect event photos without friction",
      es: "Cómo recopilar fotos de un evento sin fricción",
      ar: "كيف تجمع صور الفعالية بدون تعقيد",
    },
    excerpt: {
      fr: "Préparez le QR code, expliquez l'accès aux invités et gardez toutes les photos au même endroit.",
      en: "Prepare the QR code, explain guest access, and keep every photo in one place.",
      es: "Prepara el QR, explica el acceso y guarda todas las fotos en un solo lugar.",
      ar: "حضّر رمز QR، واشرح طريقة الدخول للضيوف، واجمع كل الصور في مكان واحد.",
    },
    readTime: { fr: "3 min", en: "3 min", es: "3 min", ar: "3 دقائق" },
    sections: {
      fr: [
        ["Préparez le partage avant l'événement", "Créez la galerie avant l'arrivée des invités, puis affichez le QR code à l'entrée, sur les tables ou dans l'invitation numérique."],
        ["Expliquez l'action en une phrase", "Un message simple suffit : scannez le code, ajoutez votre nom, puis envoyez vos meilleures photos de la soirée."],
        ["Gardez une seule source de vérité", "Évitez les photos dispersées dans plusieurs conversations. Une galerie unique rend l'expérience plus claire pour l'organisateur et les invités."],
      ],
      en: [
        ["Prepare sharing before the event", "Create the gallery before guests arrive, then display the QR code at the entrance, on tables, or inside the digital invitation."],
        ["Explain the action in one sentence", "A simple message is enough: scan the code, add your name, then upload your best photos from the event."],
        ["Keep one source of truth", "Avoid photos scattered across multiple chats. One gallery makes the experience clearer for both organizers and guests."],
      ],
      es: [
        ["Prepara el acceso antes del evento", "Crea la galería antes de que lleguen los invitados y muestra el QR en la entrada, en las mesas o en la invitación digital."],
        ["Explica la acción en una frase", "Un mensaje simple basta: escanea el código, añade tu nombre y sube tus mejores fotos del evento."],
        ["Mantén una sola fuente", "Evita fotos dispersas en varios chats. Una galería única hace la experiencia más clara para organizadores e invitados."],
      ],
      ar: [
        ["حضّر المشاركة قبل الفعالية", "أنشئ المعرض قبل وصول الضيوف، ثم اعرض رمز QR عند المدخل أو على الطاولات أو داخل الدعوة الرقمية."],
        ["اشرح الخطوة بجملة واحدة", "رسالة بسيطة تكفي: امسح الرمز، أضف اسمك، ثم ارفع أفضل صورك من الفعالية."],
        ["اجعل الصور في مكان واحد", "تجنب تشتت الصور بين محادثات متعددة. معرض واحد يجعل التجربة أوضح للمنظمين والضيوف."],
      ],
    },
  },
  {
    slug: "private-gallery-security",
    category: {
      fr: "Sécurité",
      en: "Security",
      es: "Seguridad",
      ar: "الأمان",
    },
    title: {
      fr: "Pourquoi une galerie privée rassure vos invités",
      en: "Why a private gallery makes guests feel safer",
      es: "Por qué una galería privada tranquiliza a los invitados",
      ar: "لماذا يطمئن الضيوف للمعرض الخاص",
    },
    excerpt: {
      fr: "Codes d'accès, modération et conservation limitée rendent le partage plus clair et plus sûr.",
      en: "Access codes, moderation, and limited retention make sharing clearer and safer.",
      es: "Códigos de acceso, moderación y conservación limitada hacen el uso más claro y seguro.",
      ar: "رموز الدخول والمراجعة والحفظ المحدود تجعل المشاركة أوضح وأكثر أماناً.",
    },
    readTime: { fr: "4 min", en: "4 min", es: "4 min", ar: "4 دقائق" },
    sections: {
      fr: [
        ["L'accès doit être compréhensible", "Un invité doit savoir immédiatement que la galerie n'est pas publique et qu'elle est reliée à un événement précis."],
        ["La modération protège le moment", "L'analyse des images aide à éviter les contenus déplacés avant qu'ils ne soient visibles dans l'album."],
        ["La conservation limitée réduit le risque", "Une durée claire de conservation donne confiance et évite que les photos restent en ligne indéfiniment."],
      ],
      en: [
        ["Access should be easy to understand", "Guests should immediately know the gallery is not public and belongs to a specific event."],
        ["Moderation protects the moment", "Image review helps prevent inappropriate content from appearing inside the album."],
        ["Limited retention lowers risk", "A clear retention period builds trust and avoids keeping photos online indefinitely."],
      ],
      es: [
        ["El acceso debe ser fácil de entender", "Los invitados deben saber de inmediato que la galería no es pública y pertenece a un evento específico."],
        ["La moderación protege el momento", "La revisión de imágenes ayuda a evitar contenido inapropiado antes de que aparezca en el álbum."],
        ["La conservación limitada reduce el riesgo", "Un periodo claro de conservación genera confianza y evita mantener fotos online indefinidamente."],
      ],
      ar: [
        ["يجب أن يكون الوصول واضحاً", "يجب أن يعرف الضيوف فوراً أن المعرض ليس عاماً وأنه مرتبط بفعالية محددة."],
        ["المراجعة تحمي اللحظة", "مراجعة الصور تساعد على منع ظهور المحتوى غير المناسب داخل الألبوم."],
        ["مدة الحفظ المحدودة تقلل المخاطر", "فترة حفظ واضحة تعزز الثقة وتمنع بقاء الصور على الإنترنت إلى أجل غير مسمى."],
      ],
    },
  },
  {
    slug: "mobile-photo-album",
    category: {
      fr: "Qualité",
      en: "Quality",
      es: "Calidad",
      ar: "الجودة",
    },
    title: {
      fr: "Réussir un album collaboratif sur mobile",
      en: "How to build a better collaborative album on mobile",
      es: "Cómo crear un mejor álbum colaborativo en móvil",
      ar: "كيف تنشئ ألبوماً تعاونياً أفضل على الهاتف",
    },
    excerpt: {
      fr: "Les bons réglages facilitent l'upload, évitent les doublons et préservent les meilleurs moments.",
      en: "The right settings make uploads easier, reduce duplicates, and preserve the best moments.",
      es: "Los ajustes correctos facilitan la subida, reducen duplicados y preservan los mejores momentos.",
      ar: "الإعدادات الصحيحة تسهل الرفع وتقلل التكرار وتحافظ على أفضل اللحظات.",
    },
    readTime: { fr: "3 min", en: "3 min", es: "3 min", ar: "3 دقائق" },
    sections: {
      fr: [
        ["Réduisez les étapes", "Sur mobile, chaque champ inutile fait perdre des participants. Le chemin idéal est scanner, rejoindre, envoyer."],
        ["Préservez la qualité utile", "Il faut garder une bonne qualité visuelle tout en optimisant le poids pour éviter des uploads trop longs."],
        ["Aidez les invités à revenir", "Un compte simple ou un lien sauvegardé permet aux participants de retrouver l'album après l'événement."],
      ],
      en: [
        ["Reduce the number of steps", "On mobile, every unnecessary field loses participants. The ideal path is scan, join, upload."],
        ["Preserve useful quality", "Keep strong visual quality while optimizing file size so uploads do not feel too slow."],
        ["Help guests come back", "A simple account or saved link lets participants find the album again after the event."],
      ],
      es: [
        ["Reduce los pasos", "En móvil, cada campo innecesario hace perder participantes. El flujo ideal es escanear, entrar y subir."],
        ["Preserva la calidad útil", "Mantén buena calidad visual mientras optimizas el peso para que las subidas no parezcan lentas."],
        ["Ayuda a los invitados a volver", "Una cuenta simple o un enlace guardado permite encontrar el álbum después del evento."],
      ],
      ar: [
        ["قلل عدد الخطوات", "على الهاتف، كل حقل غير ضروري يقلل المشاركة. المسار المثالي هو: مسح، انضمام، رفع."],
        ["حافظ على الجودة المفيدة", "يجب الحفاظ على جودة بصرية جيدة مع تحسين حجم الملف حتى لا يكون الرفع بطيئاً."],
        ["ساعد الضيوف على العودة", "حساب بسيط أو رابط محفوظ يسمح للمشاركين بالعودة إلى الألبوم بعد الفعالية."],
      ],
    },
  },
];

const localize = (value, lang) => value?.[lang] || value?.fr || "";

export function getBlogPosts(lang = "fr") {
  return BLOG_POSTS.map((post) => ({
    slug: post.slug,
    category: localize(post.category, lang),
    title: localize(post.title, lang),
    excerpt: localize(post.excerpt, lang),
    readTime: localize(post.readTime, lang),
    sections: post.sections?.[lang] || post.sections?.fr || [],
  }));
}

export function getBlogPost(slug, lang = "fr") {
  return getBlogPosts(lang).find((post) => post.slug === slug) || null;
}
